import React, {useState} from "react";
import Title from "../../components/containers/title/title";
import Form from "../../components/franchise/franchiseForm/franchiseForm";
import classes from "../../components/franchise/franchise.module.css";
import PromptMessage from "../../components/containers/promptMessage/promptMessage";

const Franchise = () => {
    const [isSubmitted, setIsSubmitted] = useState(false);

    return (
        <div className={classes.Container}>
            <Title title={parseInt(localStorage.getItem('language')) === 1 ? 'FRANCHISE WITH US' : 'امتياز تجاري معنا'} />
            <div className={classes.Body}>
                <p className={classes.Description}>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Be part of our global expansion and franchise with 6 Yard! Complete the form and start your journey with us"
                        : "كن جزءاً من توسعنا العالمي واحصل على امتياز تجاري مع 6 يارد! أكمل النموذج وابدأ رحلتك معنا"}
                </p>
                <Form setIsSubmitted={setIsSubmitted}/>
            </div>
            <div className={classes.LocationBackground} />
            {isSubmitted && <PromptMessage 
                successMessage 
                status={parseInt(localStorage.getItem('language')) === 1 ? 'CONGRATULATIONS' : 'تهانينا'} 
                button={parseInt(localStorage.getItem('language')) === 1 ? 'CLOSE' : 'إغلاق'}
                message={parseInt(localStorage.getItem('language')) === 1 
                    ? 'Your order was submitted successfully. We will reach you soon'
                    : 'تم تقديم طلبك بنجاح. سنتواصل معك قريباً'} 
                click={() => setIsSubmitted(false)}
            />}
        </div>
    )
}

export default Franchise;